import { render, staticRenderFns } from "./TopNavbarNotifications.vue?vue&type=template&id=12f8031e&scoped=true&"
import script from "./TopNavbarNotifications.vue?vue&type=script&lang=js&"
export * from "./TopNavbarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbarNotifications.vue?vue&type=style&index=0&id=12f8031e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8031e",
  null
  
)

export default component.exports